import request from '../request'

const server = {
    getCompanyList:function () {
        return request.post('/user-center/companyRelation/queryCompanyTree')
    },
    getOperationList:function (params) {
        return request.post('/user-center/companyRelation/queryOperationList',params)
    },
    //解除隶属关系
    releaseRelation:function (params) {
        return request.post('/user-center/companyRelation/release',params)
    },
    //提交隶属关系
    submitRelation:function (params) {
        return request.post('/user-center/companyRelation/beginOperation',params)
    },
    //子公司确认
    subCompanyConfirm:function (params) {
        return request.post('/user-center/companyRelation/sonAgree',params)
    },
    //子公司拒绝
    subCompanyRefuse:function (params) {
        return request.post('/user-center/companyRelation/sonRefuse',params)
    },
    //查询子公司待回复的隶属请求
    queryNeedReply:function (params) {
        return request.post('/user-center/companyRelation/queryNeedReply',params)
    },

}

export default server
